export const statement = {
  RelevesCompte: {
    tab: {
      graphTitle: 'Graphe Relevés',
      releverTitle: 'Analyse Relevés',
    },
    header: {
      title: 'Liste des comptes bancaires',
      buttons: {
        export: 'Exporter',
        import: 'Importer',
        releve_inco: 'Relevé inconnu',
      },
    },
    filters: {
      state: '-Etat-',
      scope: '-Scope-',
      companies: '-Société-',
      bank: '-Banque-',
      country: '-Pays-',
      devise: '-Devise-',
      format: '-Format-',
      services: "<Sélection du service pour l'intégration par job>",
    },
    searchInput: {
      caption:
        'Rechercher un compte par code, nom, numéro de compte, code société, nom de société ...',
    },
    modal: {
      titles: {
        import: "Import d'un relevé manuellement",
        export: 'Export de relevés de compte',
      },
      buttons: {
        export: 'Exporter',
        drag_file: 'Appuyer ou déposer des fichiers ici',
        drag_one_file: 'Appuyer ou déposer un fichier ici',
        send: 'Envoyer',
      },
      champ_titles: {
        job: 'Intégration par Job',
      },
    },
    columns: {
      state: 'Etat',
      code: 'Code',
      name: 'Nom',
      iban: 'IBAN',
      company: 'Société',
      bank: 'Banque',
      solde: 'Solde',
      devise: 'Devise',
      date: 'Date de solde',
      operation_number: 'Nb mouvements',
      intraday_number: 'Nb Intraday',
      alternative_account: 'Compte Alternatif',
      solde_consolide: 'Solde devise consolidé',
      devise_consolide: 'Devise de consolidation',
      pays_compte: 'Pays Banque',
      pays_soc: 'Pays Société',
      domiciliation: 'Domiciliation',
    },
    search_advanced_releve: {
      category_search: 'Catégorie',
      label_search: "Recherche d'un libellé",
    },
  },
  unknowAccount: {
    header: {
      title: 'Liste des Relevé inconnu',
    },
    columns: {
      state: 'Etat',
      unknow_account: 'Compte inconnu',
      solde: 'Solde',
      devise: 'Devise',
      date_solde: 'Date de solde',
      nb_mvt: 'Nb mouvements',
    },
    label: {
      delete: "Supprimer les mouvements temporaires",
      black_liste: "Ignorer le relevé de ce compte",
      search: "Rechercher les comptes bancaires",
      unknow: "Retirer de la liste noire",
      delete_account: "Voulez-vous supprimer les mouvements temporaires",
      search_id: "Voulez-vous rechercher les comptes bancaires",
      add_blackList: "Voulez-vous ignorer le relevé de ce compte",
      add_unknow: "Voulez-vous retirer de la liste noire"

    }
  },
  DetailRelevesCompte: {
    header: {
      title: 'Visualisation du relevé de compte {{code}} - {{iban}}',
      print: 'Imprimer',
      relever_electro: 'Relevés électronique',
      generation: 'Géneration Ecritures',
      calendar: 'Dernier jour ouvré',
      search: 'Rechercher ...',
    },
    filters: {
      state: '-Etat-',
      scope: '-Scope-',
      companies: '-Société-',
      bank: '-Banque-',
      country: '-Pays-',
      devise: '-Devise-',
    },
    searchInput: {
      caption:
        'Rechercher un compte par code, nom, numéro de compte, code société, nom de société ...',
    },
    columns: {
      label: 'Libellé',
      complementary_label: 'Libellé complémentaire',
      reference: 'Référence',
      tiers: 'Tiers',
      document_number: 'N° Pièce',
      category: 'Catégorie',
      transaction_code: 'Code',
      devise: 'Devise',
      operation_date: "Date d'opération",
      value_date: 'Date de valeur',
      debit: 'Débit',
      credit: 'Crédit',
      currency: 'Devise',
      payer_name: 'Nom du payeur',
      beneficiary_name: 'Nom du bénéficiaire',
      exempted: 'Exo',
    },
    columns_electro_relever: {
      title: 'Liste des relevés de compte électroniques',
      num_doc: 'N ° document',
      date: 'Date de début',
      date_fin: 'Date de fin',
      date_add: "Date d'ajout",
    },
    modal: {
      title: "Détail de l'operation",
    },
  },
  FraisBancaire: {
    table: {
      title: 'Frais bancaires',
      bankList_placeholder: '- Banque -',
      group_compte_list: '- Groupe de compte -',
      search: 'Rechercher',
      society_List_placeholder: '- Société -',
    },
    columns: {
      frais: 'Libellé',
      nb_op: 'Nb opération',
      verif: 'Tarification',
      balance: 'Assiette/Somme',
      currency: 'Devise',
      amount: 'Frais',
      total: 'Total',
    },
    columns_detail_assiette: {
      code_compte: 'Code compte',
      date_operation: 'Date opération',
      label_complet: 'Libellé complet',
      code_category: 'Code catégorie',
      code_opération: '	Code opération',
      code_nature_present: 'Code nature',
      montant: 'Montant ',
      devise: 'Devise ',
    },
  },
  alert_account: {
    table: {
      header: {
        title: 'Liste des alertes relevés de compte',
        load_search: 'Lancer la recherche',
      },

      columns: {
        label: 'Libellé',
        state: 'Etat',
        account: 'Compte',
        reference: 'Référence',
        nature: 'Nature',
        category: 'Catégorie',
        op_date: 'Date opé.',
        value_date: 'Date Valeur',
        amount: 'Montant',
        currency: 'Devise',
        type: 'Type',
        entry_number: 'Num Ecriture',
        nature_code: 'Code Nature',
        integration_date: "Date d'intégration",
        ics: 'ICS',
        rum: 'RUM',
        transaction_code: 'Code opération',
        rule_code: 'Code Règle',
        company: 'Société',
        exempted: 'Exo',
        debit: 'Débit',
        credit: 'Crédit',
      },
    },
  },
  analyse: {
    title: 'Soldes bancaires',
    entity: 'Société',
    benefBank: 'Banque',
    location: 'Pays',
    currency: 'Devise',
    consolidation: 'Consolidation',
  },
  agios: {
    column: {
      state: 'Etat',
      code: 'Code',
      name: 'Nom',
      banque: 'Banque',
      company: 'Société',
      iban: 'IBAN',
      devise: 'Devise',
      taux_debit: 'Taux débit',
      taux_credit: 'Taux crédit',
    },
    drawer: {
      titleDrawer: 'Résultat de calcul des agios',
      titleCalcul: 'Calcul Agios',
      compte: 'Comptes',
      periode: 'Période',
      titleResult: 'Résultat',
      assiete: 'Assiette Débiteur',
      int: 'Intérêts Débiteur',
      assiCredit: 'Assiette Créditeur',
      intCredit: 'Intérets Créditeur',
      titleDetail: 'Détail Calcul',
      accountNbr: 'Nb de comptes :',
      imp: 'Imprimer',
      column: {
        date: 'Date',
        nbJ: 'Nb jours',
        position: 'Position',
        tauxDeb: 'Taux débiteur',
        int_deb: 'Intérêts débiteur',
        tauxCred: 'Taux créditeur',
        intCredit: 'Intérêts créditeur',
      },
    },
    calcul: 'Lancer le calcul',
    title: 'Calcul des Agios',
  },
  mobileBank: {
    title: 'Liste des mobilités bancaire',
    titleVisu: 'Liste des opérations',
    action: {
      misAJourTiers: 'Mise à jour Tiers',
      exported: 'Exporter',
      stateTraiter: 'Passer en état « Traité »',
      stateNonTraiter: 'Passer en état « Non Traité »',
    },
    column: {
      state: 'Etat',
      majTiers: 'Maj Tiers',
      export: 'Export',
      userTraitement: 'User traitement',
      date: 'Date',
      dateMandat: 'Date mandat',
      nameOrigin: 'Nom origine',
      ibanOrigine: 'IBAN origine',
      nouvNom: 'Nouveau Nom',
      nouvIban: 'Nouvel IBAN',
      bicOrigin: 'BIC origine',
      nouvBic: 'Nouveau BIC',
      visualisation: 'Visualisation',
      timestamp_creation: 'Date création',
    },
    columnVisu: {
      type: 'Type',
      end_to_end_id: 'EndToEndId',
      reason: 'Motif',
      ics: 'I.C.S',
      rum: 'RUM',
    },
    modal_confirm: {
      maj_tiers: 'Voulez-vous mettre à jour les Tiers ',
      export: 'Voulez-vous exporter les mobilités ',
      traite: 'Voulez-vous passer les mobilités en état "Traité" ',
      no_traite: 'Voulez-vous passer les mobilités en état "Non Traité" ',
    },
  },
  anaysePlacement: {
    titleFinanciers: 'Placement par établissement financiers',
    titleTYpe: 'Répartition par type',
    societe: 'Placements par société',
    addPlacement: 'Ajouter les relevés',
    title: 'Analyse placement',
  },
  retourFichier: {
    title: 'Details de fichier retour',
    table: {
      title: 'Liste des fichiers Retour',
      column: {
        nId: 'N° ID',
        flux: 'Flux / Code-Nom compte',
        nomFIle: 'Nom de fichier / IBAN',
        banque: 'Banque / Nb opérations',
        fileFormat: 'Format du fichier / Montant',
        receptions: 'Réception / Remise',
      },
    },
    fiche: {
      flux: 'Flux',
      emmetteur: 'Emetteur',
      reference: 'Références',
      data_r: 'Date Réception',
      date_remise: 'Date Remise',
      nb: 'Nb',
      montantRemise: 'Montant remise',
      table: {
        num: 'N°',
        tier: 'Tiers',
        ultimateT: 'Ultimate Tiers',
        code: 'Codes',
        ref: 'Référence/Libellé',
        montant: 'Montant',
        devise: 'Devise',
      },
    },
  },
}

